import CoreuiController from "../lib/coreui-controller"
import Modal from "../coreui/modal"

export default class CoreuiModalController extends CoreuiController {
  static Component = Modal
}
